import { Columns, LegacyCard, Stack, Text } from "@shopify/polaris";
import { Field } from "react-final-form";
import TagsCheckbox from "../TagsCheckbox/TagsCheckbox.js";
import SelectedTagsField from "../../../../../common/SelectedTagsField/SelectedTagsField.js";
import React from "react";

const BackProductCard = ({ values }) => {
  return (
    <LegacyCard>
      <LegacyCard.Section>
        <Columns columns={{ xs: "1fr 1fr" }}>
          <Stack vertical>
            <Field
              name="backProductIsActiveVisibleTags"
              component={TagsCheckbox}
              label="Tag products that were made visible again by Stockhide once their stock level has recovered"
              disabled={!values.backProductIsActiveVisibleTags}
            />
            <div style={{ paddingLeft: "1.75rem" }}>
              <Field name={"backProductVisibleSelectedTags"} component={SelectedTagsField} labelHidden={true} />
            </div>
            <Field
              name="backProductIsActiveExcludeTags"
              component={TagsCheckbox}
              label="Exclude products from being “Made visible” based on a specific tag"
              disabled={!values.backProductIsActiveExcludeTags}
            />
            <div style={{ paddingLeft: "1.75rem" }}>
              <Field name={"backProductExcludeSelectedTags"} component={SelectedTagsField} labelHidden={true} />
            </div>
          </Stack>
        </Columns>
      </LegacyCard.Section>
    </LegacyCard>
  );
};

export default BackProductCard;